import React from 'react'
import styles from '../../../../containers/Forms/Forms.css'

const TextAreaInput = props => {
  const {
    input,
    meta: { touched, error, warning },
    label,
    getLabel,
    required,
    autoFocus,
    placeholder,
    disabled,
    inline,
  } = props

  const inputComponent = typeof getLabel === 'function'
    ? getLabel()
    : <span className={styles.label}>{label}</span>

  const cn = inline ? styles.inputRowGroup : styles.inputGroup

  return (
    <label
      className={cn}
      htmlFor={input.name}
    >
      {required &&
        <span className={styles.required} />
      }
      {inputComponent}
      <textarea
        {...input}
        autoComplete="off"
        className={styles.input}
        disabled={disabled}
        required={required}
        id={input.name}
        autoFocus={autoFocus}
        placeholder={placeholder}
      />
      {error && <span className={styles.error}>{error}</span>}
    </label>
  )
}

export default TextAreaInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/TextAreaInput/TextAreaInput.jsx